import React, { useEffect, useLayoutEffect, useState }
    from 'react';
import { useDispatch, useSelector }
    from 'react-redux';
import { useNavigate }
    from 'react-router-dom';
import { useLocation }
    from 'react-router-dom';
import CustomerPopupWithOrder from '../customerPopupwithOrder';
import UniqueCustomerModel from '../UniquecustomerPopup';
import { formatSupport } from '../../../../common/common';
import { setAnalysisResult, setIsProductPage } from '../../../../../store';
import { toast } from 'react-toastify';

const ProductPage = ({
    setIsClickOnSku,
    isSubComponent,
    supportFilter,
    selectedCombo,
    setCountItemSet
}) => {
    const antecedentInfo = useSelector((state) => state.analysisData.antecedentInfo);
    const analysisResult = useSelector((state) => state.analysisData.analysisResult);
    const currentAnalysisData = useSelector((state) => state.analysisData.currentAnalysisData);
    const selectedItemSetForProductPage = useSelector((state) => state.analysisData.selectedItemSetForProductPage);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { state } = useLocation();
    const order_details_id = state?.order_details_id;
    const isSingleOrderExclude = state?.isSingleOrderExclude;
    const isFavoritePage = state?.isFavoritePage;

    const [filterProductData, setFilterProductData] = useState([]);
    const [selectedItemSet, setSelectItemSet] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setModalOpen] = useState(false);
    const [uniqueCustomerModel, setUniqueCustomerModel] = useState(false);
    const [uniqueProducts, setUniqueProducts] = useState(0);
    const [isBoth, setIsBoth] = useState({
        antecedent: false,
        consequent: false,
        all: false
    });
    const [totalOrder, setTotalOrder] = useState(0);
    const [totalProducts, setTotalProducts] = useState(0)
    const [productList, setProductList] = useState([]);
    const [sku, setSku] = useState([]);
    const [mainCompleteAnalysisResult, setMainCompleteAnalysisResult] = useState([])
    const [modifiedAnalysisData, setModifiedAnalysisData] = useState([]);
    const [supportFilteredAnalysisResult, setSupportFilteredAnalysisResult] =
        useState([]);
    // const [supportFilter, setSupportFilter] = useState(null);
    const [showLoading, setShowLoading] = useState(false);


    useEffect(()=>{
        if(isFavoritePage){
            console.log(currentAnalysisData,"currentAnalysisData")
            getAnlysisResultByAnalysisDetailsId();
        }
    },[])

    useLayoutEffect(() => {
        if (!analysisResult || !currentAnalysisData) return;
        const seenAllSkus = new Set();
        const uniqueResults = [];
        for (const data of analysisResult) {
            const antecedentSkus = data.antecedents.map((sku) => sku.sku);
            const consequentSkus = data.consequent.map((sku) => sku.sku);
            const allSkus = [...new Set([...antecedentSkus, ...consequentSkus])].sort(); // sort to normalize order
            uniqueResults.push({
                ...data,
                totalPurchasedTogether: Math.round(data.support * currentAnalysisData.totalOrder),
                antecedentPurchasedTogether: Math.round(data.antecedent_support * currentAnalysisData.totalOrder),
                consequnetPurchasedTogether: Math.round(data.consequent_support * currentAnalysisData.totalOrder),
                antecedentSkus,
                consequentSkus,
                allSkus,
            });
        }
        // setSupportFilter(formatSupport(currentAnalysisData.min_support));
        setSupportFilteredAnalysisResult(uniqueResults);
        setMainCompleteAnalysisResult(uniqueResults)

    }, [analysisResult, currentAnalysisData]);

    // const handleSupportChange = (e) => {
    //     const value = e.target.value;
    //     setSupportFilter(value);
    // };


    useEffect(() => {
        const filterAnalysisDataWithSupport = mainCompleteAnalysisResult.filter(
            (result) => {
                let support = formatSupport(result.support);

                let totalPurchasedTogether = Math.round(
                    supportFilter / 100 * currentAnalysisData?.totalOrder
                )

                //   console.log(support,"support",result.support,totalPurchasedTogether,result.totalPurchasedTogether)
                return result.totalPurchasedTogether >= totalPurchasedTogether;
                // return support >= supportFilter;

            }
        );

        //   console.log(supportFilter,"supportFilter",filterAnalysisDataWithSupport.length,analysisResult.length)
        setSupportFilteredAnalysisResult(filterAnalysisDataWithSupport);

    }, [supportFilter,mainCompleteAnalysisResult])

    const itemsPerPage = 5;
    useEffect(() => {
        setCurrentPage(1);
        let totalProduct = 0;
        let totalCombinations = 0;
        const filterData = supportFilteredAnalysisResult.filter((data) => {
            let allProduct = [...data.antecedents, ...data.consequent]
            let antecedentsProducts = data.antecedents;

            if (
                antecedentsProducts.some(item => item.sku === antecedentInfo.sku)
            ) {
                if (selectedItemSetForProductPage === 0) {
                    return true
                } else if (selectedItemSetForProductPage === 1) {
                    return antecedentsProducts.length === 1
                } else if (selectedItemSetForProductPage === 2) {
                    return antecedentsProducts.length === 2
                } else if (selectedItemSetForProductPage === 3) {
                    return antecedentsProducts.length === 3
                }
                else if (selectedItemSetForProductPage === 4) {
                    return antecedentsProducts.length === 4
                }

            } else {

            }
        })

        let newFilter = [...filterData].sort(
            (a, b) => Number(b.lift) - Number(a.lift)
          );

        const uniqueSkus = new Set();
        newFilter.forEach((item) => {
            item.antecedents.forEach((data) => uniqueSkus.add(data.sku));
            item.consequent.forEach((data) => uniqueSkus.add(data.sku));
        });
        const uniqueProductCount = uniqueSkus.size;
        setUniqueProducts(uniqueProductCount);
        setTotalOrder(newFilter.length)
        setFilterProductData(newFilter);
    }, [selectedItemSetForProductPage, supportFilteredAnalysisResult])


    const handleView = (asku, csku, allsku, isSignle) => {
        setModalOpen(true);
        setSku({
            antecedentSKU: asku,
            consequentSKU: csku,
            allSku: allsku
        });
    }


    const getAnlysisResultByAnalysisDetailsId = async () => {
        try {
            setShowLoading(true)
          const response = await fetch(
            `${process.env.REACT_APP_ORDER_ANALYSIS_RESULT}?analysis_details_id=${currentAnalysisData._id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          const newResponse = await response.json();
          if (!response.ok) {
            if (newResponse?.detail?.isExpireToken) {
              const token = localStorage.removeItem("token");
              const user = localStorage.removeItem("userInfo");
              navigate("/login");
            }
            throw new Error(
              newResponse.detail?.message || "Failed to fetch analysis history"
            );
          }
    
          dispatch(setAnalysisResult(newResponse.data));
          
          toast.success("Analysis Result fetched successfully!", {
            position: "top-right",
            autoClose: 3000,
          });
        } catch (err) {
          
        } finally {
        setShowLoading(false)
        }
      };

    const totalPages = Math.ceil(filterProductData.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginateData = filterProductData.slice(startIndex, startIndex + itemsPerPage);

    if (antecedentInfo.length === 0) {
        navigate(-1)
    }
    return (
        <main className="">

            <div class="flex-1">
                <div class="">
                    <div class="bg-white rounded-xl shadow-soft sticky top-16 z-20 mb-6 p-6 border border-gray-100">
                        <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                            <div class="flex items-center space-x-4">
                                <div class="w-16 h-16 rounded-lg overflow-hidden">
                                    <img
                                        src={
                                            antecedentInfo.image
                                                ? antecedentInfo.image
                                                : "noimage.jpg"
                                        }
                                        class="w-full h-full object-cover" alt="Product" />
                                </div>
                                <div>
                                    <h2 class="font-bold text-lg">{antecedentInfo?.product_title}</h2>
                                    <div class="text-gray-500 text-sm">SKU: {antecedentInfo?.sku}</div>
                                </div>
                            </div>
                            {/* <div class="flex  justify-end space-x-4 pull-right">

                                <div class="bg-blue-50 rounded-lg p-4 mt-6"><div class="flex flex-wrap justify-center md:justify-between items-center"><div class="flex items-center mb-2 md:mb-0"><div class="bg-blue-100 p-3 rounded-full mr-3"><i class="fas fa-shopping-cart text-blue-600"></i></div><div><p class="text-sm text-gray-600">Total Combinations <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span></p><p class="text-xl font-bold text-blue-700">{totalOrder} Combinations</p></div></div><div class="flex items-center mb-2 md:mb-0"><div class="bg-green-100 p-3 rounded-full mr-3"><i class="fas fa-users text-green-600"></i></div><div><p class="text-sm text-gray-600">Unique Products <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span></p><p class="text-xl font-bold text-green-700">{uniqueProducts} products</p></div></div></div></div>




                            </div> */}
                            <div className="flex justify-end flex-wrap gap-4">
                                <div className="flex items-end">
                                    <button
                                        className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300 transition duration-300"
                                        onClick={() => {
                                            if(isSubComponent){
                                                setIsClickOnSku(false)
                                                dispatch(setIsProductPage(false))
                                            }else{
                                                navigate(-1)
                                            }
                                        }}
                                    >
                                        ← Back
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        !showLoading && 
                        <div class="flex flex-col lg:flex-row gap-8">
                        <div class="flex-1">
                            <h3 class="text-lg font-semibold text-gray-900 mb-4">Frequently Bought Together</h3>
                            <div id="combos-grid" class="grid grid-cols-1 gap-4">
                                {
                                    paginateData.length > 0 && paginateData.map((row, i) => {
                                        return <div class="bg-white rounded-xl shadow-soft hover-lift card-transition animate-fadein overflow-hidden">
                                            <div class="p-4 flex items-center justify-center relative h-40">
                                                {[...row.antecedents]
                                                    .filter((data) => data.sku !== antecedentInfo.sku) // ❌ Skip current SKU
                                                    .map((data, index, arr) => (
                                                        <React.Fragment key={index}>
                                                            <div className="flex items-center">
                                                                {/* Product Image */}
                                                                <div className="product-combo-image w-20 h-20 rounded-lg overflow-hidden mx-2">
                                                                    <img
                                                                        src={data.image || "noimage.jpg"}
                                                                        className="w-full h-full object-cover"
                                                                        alt="Product"
                                                                    />
                                                                </div>

                                                                {/* "+" symbol (only between items) */}
                                                                {index !== arr.length - 1 ? (
                                                                    <div className="text-xl font-bold text-gray-400 mx-1">+</div>
                                                                ):(
                                                                    <div className="text-xl font-bold text-gray-400 mx-1">-&gt;</div>
                                                                )}
                                                            </div>
                                                        </React.Fragment>
                                                ))}
                                                {[...row.consequent]
                                                    .filter((data) => data.sku !== antecedentInfo.sku) // ❌ Skip current SKU
                                                    .map((data, index, arr) => (
                                                        <React.Fragment key={index}>
                                                            <div className="flex items-center">
                                                                {/* Product Image */}
                                                                <div className="product-combo-image w-20 h-20 rounded-lg overflow-hidden mx-2">
                                                                    <img
                                                                        src={data.image || "noimage.jpg"}
                                                                        className="w-full h-full object-cover"
                                                                        alt="Product"
                                                                    />
                                                                </div>

                                                                {/* "+" symbol (only between items) */}
                                                                {index !== arr.length - 1 && (
                                                                    <div className="text-xl font-bold text-gray-400 mx-1">+</div>
                                                                )}
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                            </div>
                                            <div class="p-4 border-t border-gray-100">
                                                <h4 class="font-medium text-gray-900">
                                                    {   
                                                        [...row.antecedents]
                                                            .filter((data) => data.sku !== antecedentInfo.sku)  // ✅ skip current SKU
                                                            .map((data, index, arr) => (
                                                                <React.Fragment key={index}>
                                                                    {data?.product_title}

                                                                    {index !== arr.length - 1 ? (
                                                                        " + "
                                                                    ):(
                                                                        " -> "
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                    }
                                                    {
                                                        [...row.consequent]
                                                            .filter((data) => data.sku !== antecedentInfo.sku)  // ✅ skip current SKU
                                                            .map((data, index, arr) => (
                                                                <React.Fragment key={index}>
                                                                    {data?.product_title}

                                                                    {index !== arr.length - 1 && (
                                                                        " + "
                                                                    )}
                                                                </React.Fragment>
                                                            ))
                                                    }
                                                </h4>
                                                <div class="flex justify-between items-center mt-2">
                                                    <div class="text-sm text-gray-500">SKU:

                                                        {
                                                            [...row.antecedents]
                                                                .filter((data) => data.sku !== antecedentInfo.sku)  // ✅ skip current SKU
                                                                .map((data, index, arr) => (
                                                                    <React.Fragment key={index}>
                                                                        {data?.sku}

                                                                        {index !== arr.length - 1 ? (
                                                                            " + "
                                                                        ):(" -> ")}
                                                                    </React.Fragment>
                                                                ))
                                                        }

                                                        {
                                                            [...row.consequent]
                                                                .filter((data) => data.sku !== antecedentInfo.sku)  // ✅ skip current SKU
                                                                .map((data, index, arr) => (
                                                                    <React.Fragment key={index}>
                                                                        {data?.sku}

                                                                        {index !== arr.length - 1 && (
                                                                            " + "
                                                                        )}
                                                                    </React.Fragment>
                                                                ))
                                                        }
                                                    </div>
                                                    <div class="flex space-x-2 cursor-pointer"
                                                        onClick={() => {
                                                            handleView(row?.antecedentSkus, row?.consequentSkus, row?.allSkus, true)
                                                            setIsBoth({
                                                                antecedent: false,
                                                                consequent: false,
                                                                all: true
                                                            })
                                                            setProductList(row)
                                                        }}
                                                    >
                                                        <span class="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">{Math.round(row.support * currentAnalysisData?.totalOrder)} Orders</span>
                                                        <span class="bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded">{row?.together_customer_count} Customers</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    })
                                }
                                {
                                    paginateData.length === 0 && (
                                        <div className="text-center p-4 mt-6 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                            <p className="text-sm">No data found.</p>
                                        </div>
                                    )
                                }

                            </div>
                            {totalPages > 1 && (
                                <div className="p-4 border-t flex justify-between items-center bg-gray-50 flex-wrap gap-2 text-sm">

                                    {/* Previous Button */}
                                    <button
                                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                        className="px-3 py-1 bg-gray-200 text-gray-700 rounded disabled:opacity-50"
                                    >
                                        Previous
                                    </button>

                                    {/* Page Buttons */}
                                    <div className="flex items-center flex-wrap gap-1">
                                        {(() => {
                                            const rawPages = Array.from({ length: totalPages }, (_, i) => i + 1);

                                            // Remove duplicates before ellipsis processing
                                            const filteredPages = rawPages.filter((page) =>
                                                page === 1 ||
                                                page === totalPages ||
                                                Math.abs(page - currentPage) <= 1
                                            );

                                            // Remove duplicates explicitly
                                            const uniquePages = Array.from(new Set(filteredPages)).sort((a, b) => a - b);

                                            const displayPages = uniquePages.reduce((acc, page, idx, arr) => {
                                                if (idx > 0 && page - arr[idx - 1] > 1) {
                                                    acc.push("ellipsis");
                                                }
                                                acc.push(page);
                                                return acc;
                                            }, []);

                                            return displayPages.map((page, idx) =>
                                                page === "ellipsis" ? (
                                                    <span key={`ellipsis-${idx}`} className="px-2 text-gray-500">...</span>
                                                ) : (
                                                    <button
                                                        key={page}
                                                        onClick={() => setCurrentPage(page)}
                                                        className={`px-3 py-1 rounded ${currentPage === page
                                                            ? "bg-blue-500 text-white"
                                                            : "bg-gray-200 text-gray-700"
                                                            }`}
                                                    >
                                                        {page}
                                                    </button>
                                                )
                                            );
                                        })()}
                                    </div>

                                    {/* Next Button */}
                                    <button
                                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                        className="px-3 py-1 bg-gray-200 text-gray-700 rounded disabled:opacity-50"
                                    >
                                        Next
                                    </button>
                                </div>
                            )}

                        </div>

                        <div class="lg:w-80 xl:w-96 space-y-6">

                            <div class="flex justify-end space-x-4 pull-right">
                                <div class="bg-blue-50 rounded-lg p-4 mt-6">
                                    <div class="flex flex-wrap justify-center md:justify-between items-center gap-6">

                                        <div class="flex items-center mb-2 md:mb-0">
                                            <div class="bg-blue-100 p-3 rounded-full mr-3">
                                                <i class="fas fa-shopping-cart text-blue-600"></i>
                                            </div>
                                            <div>
                                                <p class="text-sm text-gray-600">
                                                    Total Combinations
                                                    <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span>
                                                </p>
                                                <p class="text-xl font-bold text-blue-700">{totalOrder} Combinations</p>
                                            </div>
                                        </div>

                                        <div class="flex items-center mb-2 md:mb-0">
                                            <div class="bg-green-100 p-3 rounded-full mr-3">
                                                <i class="fas fa-users text-green-600"></i>
                                            </div>
                                            <div>
                                                <p class="text-sm text-gray-600">
                                                    Unique Products
                                                    <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span>
                                                </p>
                                                <p class="text-xl font-bold text-green-700">{uniqueProducts} products</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            {
                                paginateData.length > 0 &&
                                <div class="bg-white rounded-xl shadow-soft p-6 sticky top-32">
                                    <h3 class="text-lg font-semibold text-blue-900 mb-4">Recommended Actions</h3>
                                    <div class="space-y-4">
                                        <div class="bg-blue-50 rounded-lg p-4 flex items-start gap-3">
                                            <div class="w-8 h-8 rounded-full  flex items-center justify-center glow-effect">
                                                <i class="fas fa-heart text-blue-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <h4 class="font-medium text-blue-600">You May Also Like</h4>
                                                <p class="text-sm text-gray-600 mt-1">Show complementary products based on customer browsing behavior and preferences. These should be items similar in style, function, or category to what they're viewing.</p>
                                                <div class="flex flex-wrap gap-2 mt-2">
                                                    <span class="tag bg-blue-100 text-gray-700 px-3 py-1 rounded-full text-sm">Personalized</span>
                                                    <span class="tag bg-blue-100 text-gray-700 px-3 py-1 rounded-full text-sm">Similar Items</span>
                                                    <span class="tag bg-blue-100 text-gray-700 px-3 py-1 rounded-full text-sm">Alternative Choices</span>
                                                </div>
                                            </div>

                                        </div>


                                        <div class="bg-purple-50 rounded-lg p-4 flex items-start gap-3">
                                            <div class="w-8 h-8 rounded-full  flex items-center justify-center glow-effect">
                                                <i class="fas fa-shopping-basket text-purple-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <h4 class="font-medium text-purple-600">Frequently Bought Together</h4>
                                                <p class="text-sm text-gray-600 mt-1">Bundle products that are commonly purchased together, showing customers they can get everything they need in one convenient purchase.</p>
                                                <div class="flex flex-wrap gap-2 mt-2">
                                                    <span class="tag bg-purple-100 text-gray-700 px-3 py-1 rounded-full text-sm">Bundles</span>
                                                    <span class="tag bg-purple-100 text-gray-700 px-3 py-1 rounded-full text-sm">Complete Kits</span>
                                                    <span class="tag bg-purple-100 text-gray-700 px-3 py-1 rounded-full text-sm">Essential Pairings</span>
                                                </div>
                                            </div>

                                        </div>

                                        {
                                            selectedItemSet !== 1 &&
                                            <>
                                                <div class="bg-yellow-50 rounded-lg p-4 flex items-start gap-3">
                                                    <div class="w-8 h-8 rounded-full  flex items-center justify-center glow-effect">
                                                        <i class="fas fa-cart-plus text-yellow-600 text-xl"></i>
                                                    </div>
                                                    <div>
                                                        <h4 class="font-medium text-yellow-600">Cart/Checkout Upsell</h4>
                                                        <p class="text-sm text-gray-600 mt-1">Bundle products that are commonly purchased together, showing customers they can get everything they need in one convenient purchase.</p>
                                                        <div class="flex flex-wrap gap-2 mt-2">
                                                            <span class="tag bg-yellow-100 text-gray-700 px-3 py-1 rounded-full text-sm">Last Chance</span>
                                                            <span class="tag bg-yellow-100 text-gray-700 px-3 py-1 rounded-full text-sm">Free Shipping</span>
                                                            <span class="tag bg-yellow-100 text-gray-700 px-3 py-1 rounded-full text-sm">Small Add-ons</span>
                                                        </div>
                                                    </div>

                                                </div>



                                                <div class="bg-red-50 rounded-lg p-4 flex items-start gap-3">
                                                    <div class="w-8 h-8 rounded-full  flex items-center justify-center glow-effect">
                                                        <i class="fas fa-box-open text-red-600 text-xl"></i>
                                                    </div>
                                                    <div>
                                                        <h4 class="font-medium text-red-600">Post-Purchase Upsell</h4>
                                                        <p class="text-sm text-gray-600 mt-1">Offers related products, replenishables, or subscription options after the initial purchase through email or order confirmation pages.</p>
                                                        <div class="flex flex-wrap gap-2">
                                                            <span class="tag bg-red-100 text-gray-700 px-3 py-1 rounded-full text-sm">Follow-up</span>
                                                            <span class="tag bg-red-100 text-gray-700 px-3 py-1 rounded-full text-sm">Replenishment</span>
                                                            <span class="tag bg-red-100 text-gray-700 px-3 py-1 rounded-full text-sm">Subscription</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }

                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    }
                    {
                        showLoading &&
                        <div className="flex justify-center py-10">
                            <div className="w-8 h-8 border-4 border-blue-300 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                    }
                </div>
            </div>
            {isModalOpen && order_details_id && (
                <CustomerPopupWithOrder
                    isOpen={isModalOpen}
                    onClose={() => setModalOpen(false)}
                    order_details_id={order_details_id}
                    sku={sku}
                    isBoth={isBoth}
                    isSingleExclude={isSingleOrderExclude}
                    productList={productList}
                >
                    This is a simple popup modal using React and Tailwind CSS.
                </CustomerPopupWithOrder>
            )}
            {uniqueCustomerModel && order_details_id && (
                <UniqueCustomerModel
                    isOpen={uniqueCustomerModel}
                    onClose={() => setUniqueCustomerModel(false)}
                    order_details_id={order_details_id}
                    sku={sku}
                    isBoth={isBoth}
                    isSingleExclude={isSingleOrderExclude}
                    productList={productList}
                />
            )}
        </main>
    );
};
export default ProductPage;
